import {
  CREATE_TALKJS_SESSION,
  UPDATE_UNREAD_CHATS,
  LOGOUT_USER,
} from '../actions/types';

const INITIAL_STATE = {
  chatSession: null,
  unreadMessages: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_TALKJS_SESSION:
      return { ...state, chatSession: action.payload };
    case UPDATE_UNREAD_CHATS:
      let unreadBySearchId = {};
      action.payload.forEach((unread) => {
        const searchId = unread.lastMessage.conversation.custom.search;
        if (!unread.lastMessage.isByMe)
          if (unreadBySearchId[searchId]) unreadBySearchId[searchId] += 1;
          else unreadBySearchId[searchId] = 1;
      });
      return { ...state, unreadMessages: unreadBySearchId };
    case LOGOUT_USER:
      return { chatSession: null, unreadMessages: {} };
    default:
      return state;
  }
};
